import axios from "axios";
import { auth } from "./firebase";
const API = axios.create({
  baseURL: "https://django-backend-268595588685.asia-south1.run.app/api"
});
API.interceptors.request.use(
  async (config) => {
    // Wait for Firebase to initialize if it hasn't already
    await auth.authStateReady(); 
    const user = auth.currentUser;
    if (user) {
      try {
        // Force refresh is false by default; gets the latest valid token
        const token = await user.getIdToken(); 
        config.headers.Authorization = `Bearer ${token}`;
      } catch (e) {
        console.error("Interceptor: Could not get token", e);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export default API;